"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.prismPalette = void 0;

/**
 * A Palette of colors for data visualizations
 */
var prismPalette = {
  prism10: '#DEF2F1',
  prism30: '#C3EAE7',
  prism60: '#8EDDD4',
  prism: '#36BCA2',
  prismDark: '#1A9F90',
  prismDarkest: '#09786C'
};
exports.prismPalette = prismPalette;